require("./bootstrap");
import Locale from "./language";
//import ObserveForLazyLoad from "./lazyload";


import Vuelidate from "vuelidate";
import Vue from "vue";
import store from "./store/";
import Carousel3d from 'vue-carousel-3d';


Vue.use(Vuelidate);
Vue.use(Carousel3d);

import VueYoutube from "vue-youtube";
Vue.use(VueYoutube);

// https://jasonwatmore.com/post/2019/08/21/vue-js-simple-pagination-example
import JwPagination from 'jw-vue-pagination'
Vue.component('jw-pagination', JwPagination);


import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";

import VModal from "vue-js-modal";
Vue.use(VModal);

import VueCookie from "vue-cookie";
Vue.use(VueCookie);

import vSelect from "vue-select";
Vue.component("v-select", vSelect);

// Vue.component("app-switcher", require("./components/switcher.vue").default);
Vue.component(
    "cross-fade-slider",
    require("./components/cross-fade-slider.vue").default
);


import VueRecaptcha from "vue-recaptcha";
Vue.component("VueRecaptcha", VueRecaptcha);


Vue.component(
    "login-form",
    require("./components/login/login-form.vue").default
);

Vue.component(
    "filmbox",
    require("./components/filmbox.vue").default
);

Vue.component(
    "session-storage",
    require("./components/session-storage.vue").default
);

Vue.component(
    "load-rating-calculator",
    require("./components/load-rating-calculator.vue").default
);

Vue.component(
    "load-rating-product",
    require("./components/load-rating-product.vue").default
);

Vue.component(
    "video-list",
    require("./components/video-list.vue").default
);

Vue.component(
    "video-card-slider",
    require("./components/video-card-slider.vue").default
);

Vue.component(
    "article-list",
    require("./components/article-list.vue").default
);

Vue.component(
    "article-list-items",
    require("./components/article-list-items.vue").default
);

Vue.component(
    "cookie-consent-bar",
    require("./components/cookie-consent-bar.vue").default
);

Vue.component(
    "compare-checkbox",
    require("./components/compare-checkbox.vue").default
);

Vue.component(
    "compare-bar",
    require("./components/compare-bar.vue").default
);

Vue.component(
    "form-wizard",
    require("./components/form-wizard.vue").default
);

Vue.component(
    "youtube-video",
    require("./components/youtube-video.vue").default
);
Vue.component(
    "youtube-popup",
    require("./components/youtube-popup.vue").default
);

Vue.component("accordion", require("./components/accordion.vue").default);
Vue.component(
    "find-a-dealer",
    require("./components/find-a-dealer.vue").default
);
Vue.component(
    "store-locator",
    require("./components/store-locator.vue").default
);

Vue.component(
    "postcode-search",
    require("./components/postcode-search.vue").default
);

Vue.component(
    "store-locator-wishlist",
    require("./components/store-locator-wishlist.vue").default
);


Vue.component(
    "booking-form",
    require("./components/booking-form.vue").default
);
/*Vue.component(
    "mobile-nav",
    require("./components/navigation/mobile-nav.vue").default
);*/


/** Solutions */
Vue.component("solutions", require("./components/solutions/index.vue").default);
Vue.component("solution-items", require("./components/solutions/solution-items.vue").default);
Vue.component("solution-item", require("./components/solutions/solution-item.vue").default);
Vue.component("platform-type", require("./components/solutions/platform-type.vue").default);
Vue.component("products", require("./components/solutions/products.vue").default);
Vue.component("item-step", require("./components/solutions/item-step.vue").default);
Vue.component("canopy-manufacturers", require("./components/solutions/canopy/manufacturers.vue").default);
Vue.component("vehicle-drilldown", require("./components/solutions/roof/vehicle-drilldown.vue").default);


/** End Solutions */

/** Solutions - New */
Vue.component("new-solutions", require("./components/solutions-new/index.vue").default);
Vue.component("new-solution-items", require("./components/solutions-new/solution-items.vue").default);
Vue.component("solution-item-new", require("./components/solutions-new/solution-item.vue").default);
Vue.component("new-platform-type", require("./components/solutions-new/platform-type.vue").default);
Vue.component("new-products", require("./components/solutions-new/products.vue").default);
Vue.component("new-item-step", require("./components/solutions-new/item-step.vue").default);
Vue.component("new-canopy-manufacturers", require("./components/solutions-new/canopy/manufacturers.vue").default);
Vue.component("new-vehicle-drilldown", require("./components/solutions-new/roof/vehicle-drilldown.vue").default);
Vue.component("solution-slider", require("./components/solutions-new/solution-slider.vue").default);
Vue.component("vehicle-drilldown-new", require("./components/solutions-new/roof/vehicle-drilldown.vue").default);

/** End Solutions - New */

Vue.component("vehicle-selector", require("./components/vehicle/vehicle-selector.vue").default);
Vue.component("vehicle-gallery", require("./components/vehicle/vehicle-gallery.vue").default);
Vue.component("video-card-gallery", require("./components/vehicle/video-card-gallery.vue").default);


Vue.component(
    "custom-javascript",
    require("./components/custom-javascript").default
);

Vue.component(
    "dealermode-header",
    require("./components/dealermode-header.vue").default
);

Vue.component(
    "cart-header",
    require("./components/wish-list/cart-header.vue").default
);

Vue.component(
    "wishlist-header",
    require("./components/wish-list/wishlist-header.vue").default
);


Vue.component(
    "wish-list-add-button",
    require("./components/wish-list/add-to-wishlist.vue").default
);

Vue.component(
    "wishlist-zwifloc",
    require("./components/wish-list/wishlist-zwifloc.vue").default
);

Vue.component(
    "wishlist-fit-zwifloc",
    require("./components/wish-list/wishlist-fit-zwifloc.vue").default
);

Vue.component(
    "wishlist-multiple",
    require("./components/wish-list/wishlist-multiple.vue").default
);
Vue.component(
    "find-a-dealer-button",
    require("./components/wish-list/find-a-dealer.vue").default
);

Vue.component(
    "add-to-cart-button",
    require("./components/wish-list/add-to-cart.vue").default
);

Vue.component(
    "wish-list-index",
    require("./components/wish-list/cart-list.vue").default
);
Vue.component(
    "product-header-slider",
    require("./components/product/product-header-slider.vue").default
);
Vue.component(
    "sort-filter",
    require("./components/product/sort-filter.vue").default
);
Vue.component(
    "owner-photos-slider",
    require("./components/product/owner-photos-slider.vue").default
);
Vue.component(
    "product-testimonials",
    require("./components/product/testimonials.vue").default
);
Vue.component(
    "product-video",
    require("./components/product/video.vue").default
);
Vue.component(
    "product-alert",
    require("./components/product/alert.vue").default
);
Vue.component(
    "dealer-pricing",
    require("./components/product/dealer-pricing.vue").default
);

Vue.component(
    "header-pricing",
    require("./components/product/header-pricing.vue").default
);

Vue.component(
    "reconfigure-solution",
    require("./components/product/reconfigure-solution.vue").default
);

Vue.component("locally-product", require("./components/product/locally-product.vue").default);

Vue.component(
    "black-bar",
    require("./components/header/black-bar.vue").default
);

Vue.component(
    "search-form",
    require("./components/search-form.vue").default
);

Vue.component(
    "dealer-solutions",
    require("./components/dealer-solutions/index.vue").default
);
Vue.component(
    "dealer-roof",
    require("./components/dealer-solutions/dealer-roof.vue").default
);
Vue.component(
    "dealer-canopy",
    require("./components/dealer-solutions/dealer-canopy.vue").default
);

Vue.component(
    "filter-pricerange-setter",
    require("./components/filter-pricerange-setter.vue").default
);

Vue.component(
    "filter-select",
    require("./components/filter-select.vue").default
);

Vue.component(
    "checkbox-group",
    require("./components/checkbox-group.vue").default
);

Vue.component(
    "search-results",
    require("./components/search-results.vue").default
);

Vue.component(
    "order-pad",
    require("./components/order-pad/order-pad.vue").default
);
Vue.component(
    "order-pad-header",
    require("./components/order-pad/order-pad-header.vue").default
);

Vue.component(
    "digital-asset-management",
    require("./components/dam/index.vue").default
);

Vue.component(
    "footer-subscribe",
    require("./components/footer/subscribe.vue").default
);

Vue.component(
    "video-3d-slider",
    require("./components/video-3d-slider.vue").default
);

Vue.component(
    "video-chunk-slider",
    require("./components/video-chunk-slider.vue").default
);

Vue.component(
    "discover-banner",
    require("./components/discover-banner.vue").default
);

Vue.component(
    "pioneer6-features",
    require("./components/pioneer6-features.vue").default
);

Vue.component(
    "pioneer6-accessories",
    require("./components/pioneer6-accessories.vue").default
);

Vue.component(
    "pioneer6-comparision",
    require("./components/pioneer6-comparision.vue").default
);

Vue.component(
    "pioneer6-explore",
    require("./components/pioneer6-explore.vue").default
);

Vue.component(
    "pioneer6-explore-v2",
    require("./components/pioneer6-explore-v2.vue").default
);

Vue.component(
    "pioneer6-explore-generic",
    require("./components/pioneer6-explore-generic.vue").default
);

Vue.directive('pioneer6-adventure-setups', require('./directives/pioneer6-adventure-setups.vue').default);
Vue.directive('explore-touch', require('./directives/explore-touch.vue').default);

Vue.component(
    "add-to-cart-parent",
    require("./components/cart/add-to-cart-parent.vue").default
);

Vue.component(
    "add-to-cart-child",
    require("./components/cart/add-to-cart-child.vue").default
);

Vue.component(
    "product-stock-availability-child",
    require("./components/product/product-stock-availability-child").default
)

Vue.component(
    "add-to-cart-standalone",
    require("./components/cart/add-to-cart-standalone.vue").default
);

Vue.component(
    "add-to-cart-standalone-multiple",
    require("./components/cart/add-to-cart-standalone-multiple.vue").default
);

Vue.component(
    "add-to-cart-stockcode-only",
    require("./components/cart/add-to-cart-stockcode-only.vue").default
);

Vue.component("VueSlider", VueSlider);
Vue.directive("box-list", require("./components/box-list.vue").default);

Vue.component('product-header-items', require('./components/product-header-items.vue').default);

// Register a global custom directive called `v-focus`
Vue.directive('pioneer-header', require('./directives/pioneer-header.vue').default)
Vue.directive('pioneer-carousel', require('./directives/pioneer-carousel.vue').default)
Vue.directive('pioneer-gallery', require('./directives/pioneer-gallery.vue').default)
Vue.directive('pioneer-video', require('./directives/pioneer-video.vue').default)
Vue.directive('pioneer-accessories', require('./directives/pioneer-accessories.vue').default)

Vue.component(
    "truckbed-slider",
    require("./components/product/truckbed-slider.vue").default
);
Vue.directive('truckbed-bars', require('./directives/truckbed-bars.vue').default);
Vue.directive('truckbed-adventure-setups', require('./directives/truckbed-adventure-setups.vue').default);
Vue.directive('truckbed-videos', require('./directives/truckbed-videos.vue').default);
Vue.directive('truckbed-video', require('./directives/truckbed-video.vue').default);
Vue.directive('truckbed-gallery', require('./directives/truckbed-gallery.vue').default)
Vue.directive('truckbed-navigation', require('./directives/truckbed-navigation.vue').default)


// Polaris Landing Page
Vue.directive('polaris-explore', require('./directives/polaris-explore.vue').default);
Vue.directive('polaris-gallery', require('./directives/polaris-gallery.vue').default);
Vue.directive('polaris-video', require('./directives/polaris-video.vue').default);
Vue.directive('polaris-discover', require('./directives/polaris-discover').default);
Vue.directive('polaris-solutions', require('./directives/polaris-solutions').default);
Vue.directive('polaris-carousel', require('./directives/polaris-carousel').default);

//  Stow iT Landing Page
Vue.component('stow-it-solutions', require('./components/stow-it/solutions.vue').default);
Vue.directive('stow-it-carousel', require('./directives/stow-it/carousel').default);
Vue.directive('stow-it-videos', require('./directives/stow-it/videos.vue').default);
Vue.directive('stow-it-video', require('./directives/stow-it/video.vue').default);

//  Zwifloc Landing Page
Vue.component('zwifloc-products', require('./components/zwifloc/products.vue').default);
Vue.component('ZwiflocTabs', require('./components/zwifloc/ZwiflocTabs.vue').default);
Vue.component('fit-my-accessory', require('./components/zwifloc/fit-my-accessory.vue').default);
Vue.directive('zwifloc-carousel', require('./directives/zwifloc/carousel').default);
Vue.directive('zwifloc-videos', require('./directives/zwifloc/videos.vue').default);
Vue.directive('zwifloc-video', require('./directives/zwifloc/video.vue').default);
Vue.directive('zwiflocproducts', require('./directives/zwifloc/zwiflocproducts.vue').default);
Vue.directive('zwiflocincluded', require('./directives/zwifloc/zwiflocincluded.vue').default);


Vue.component(
    "compatible-vehicles",
    require("./components/product/compatible-vehicles.vue").default
);


new Vue({
    el: "#app",
    store,
    data: {
        mobileNavVisible: false,
        searchVisible: false,
        priceRange: [141, 346],
        isDealer: false
    },
    mounted() {
        this.getDealer();
    },
    methods: {
        async getDealer() {
            let response = await axios.get((window.culture ? "/" + window.culture : "") + `/api/isDealer/`);
            this.isDealer = response.data.is_dealer === 1;
            this.searchVisible = this.isDealer;
        },
        toggleMobileMenu() {
            this.mobileNavVisible = !this.mobileNavVisible;
            this.searchVisible = !this.searchVisible;
        }
    }
});

$(document).ready(function() {

    $(".popular-vehicles-slider").owlCarousel({
        nav: true,
        // autoplay: true,
        dots: false,
        responsive: {
            0: {
                items: 1
            },
            768: {
                items: 3
            },
            1200: {
                items: 5
            }
        },
        onRefreshed: function(event) {
            centreCarousel();
        },
    });

    centreCarousel();

    $(window).resize(function() {
        centreCarousel();
    });

    $(".products-slider, .related-products-slider").owlCarousel({
        nav: true,
        // autoplay: true,
        responsive: {
            0: {
                items: 1
            },
            768: {
                items: 3
            },
            992: {
                items: 4
            }
        }
    });


    if($(".sale-products-slider").length > 0) {
        $(".sale-products-slider").owlCarousel({
            nav: true,
            // autoplay: true,
            responsive: {
                0: {
                    items: 1
                },
                768: {
                    items: 3
                },
                992: {
                    items: 4
                }
            }
        });

        var maxHeight = Math.max.apply(null, $(".sale-products-slider .item-wrapper").map(function ()
        {
            return $(this).height();
        }).get());

        $(".sale-products-slider .item-wrapper").height(maxHeight);
    }
});

// Switcher slider - server side rendering
$(document).ready(function() {
    var owl = $(".owl-carousel-switcher");
    owl.owlCarousel({
        stagePadding: 0,
        items: 1,
        dotsEach: true,
        autoplay: true,
        autoplayTimeout: 8000,
        smartSpeed: 1001,
        loop: true,
        autoWidth: true,
        dotsClass: 'owl-dots-switcher',
        video : true,
    });


    $('.owl-video-play-icon').on('click',function(){
        owl.trigger('stop.owl.autoplay')
    })

    owl.on('translate.owl.carousel',function(e){
        $('.owl-item video').each(function(){
            $(this).get(0).pause();
        });
    });

    owl.on('translated.owl.carousel',function(e){
        if($('.owl-item.active video').length){
            $('.owl-item.active video').get(0).play();
        }
    })

    $('.owl-item .item').each(function(){

      let attr = $(this).attr('data-video-src');
      let urlAttr = $(this).attr('data-url') ?? 'javascript:void';

      if (typeof attr !== typeof undefined && attr !== false) {
        let videoSrc = $(this).attr('data-video-src');
        $(this).prepend('<a href=\"'+ urlAttr +'\"><video muted><source src="'+ videoSrc +'" type="video/mp4"></video></a>');
      }
    });

    $('.owl-item.active video').attr('autoplay', true).attr('loop', true);

});

// alert(window.navigator.userAgent);

$(document).ready(function() {
    $(document.links).filter(function() {
        var __link_id = $(this).attr('id'); 
        if (__link_id && __link_id.indexOf('lcly-location-prompt-link') > -1) {
            return false;
        }
        return this.hostname != window.location.hostname && this.hostname != 'javascript:;' && this.hostname != 'javascript:void();' && this.hostname != '#';
    }).attr('target', '_blank');

    $('.bglazyload').each(function() {
        var lazy = $(this);
        var src = lazy.attr('data-src');
        lazy.css('background-image', 'url("' + src + '")');
    });
});

$(document).ready(function() {
    var isDragging = false;
    $('.clickable-slider')
    .mousedown(function() {
        $(window).mousemove(function() {
            isDragging = true;
            $(window).unbind("mousemove");
        });
    })
    .mouseup(function() {
        var wasDragging = isDragging;
        isDragging = false;
        $(window).unbind("mousemove");
        if (!wasDragging) {
            var url = $(this).data("url");
            if(url){
                ga('send', 'event', "Home Switcher - " + window.culture, $(this).data("title"));
                window.location.href = url;
            }
        }
    });

    $('.sub-menu a').each(function(index, item) {
        if (window.location.pathname.endsWith($(item).attr('href'))) {
            $(item).addClass('active')
        }
    });

    $('.home-switcher-btn').click(function(){
            ga('send', 'event', "Home Switcher - " + window.culture, $(this).data("switcher-title"));
            var url = $(this).data("switcher-url");
            if(url) window.location.href = url;
            return false;
    });
});


function  foobar(event){

    console.log('event', event);


}

$(document).ready(function() {
    var acc = document.getElementsByClassName("footer-accordion");
    var i;

    for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function() {
            this.classList.toggle("expanded");
            var panel = this.nextElementSibling;
            panel.classList.toggle("expanded");

        });
    }

    //$('#app>div.content').css('padding-top', $('header').height())

    $(window).resize(function() {
        $('#app>div.content').css('padding-top', $('header').height())

        $('.page-header-desktop, .owl-item').each(function() {
            var ctl = $(this).find('.text');
            var padding = ($(this).height() - ctl.height()) / 2;
            ctl.css({'margin-top': padding + 'px'});
        })
    });

    $('.page-header-desktop, .owl-item').each(function() {
        var ctl = $(this).find('.text');
        var padding = ($(this).height() - ctl.height()) / 2;
        ctl.css({'margin-top': padding + 'px'});
    })
});

if(document.querySelector('.pioneer-tab-items')){
    $('.pioneer-tabs').owlCarousel({
        loop:false,
        margin:30,
        nav:true,
        dots: false,
        autoWidth:true,
        responsive:{
            0:{
                items:1
            },
            1000:{
                items:4
            },
            1200:{
                items:5
            }
        }
    })
    document.querySelectorAll('.pioneer-tab-items').forEach((section) => {
        section.querySelectorAll('.pioneer-tabs .tab').forEach((tab) => {
            tab.addEventListener('click', () => {
                changeTab(tab.getAttribute('data-id'));
            })
        })

        const selectedOption = document.getElementById("pioneer-tab-items-selected-option");
        const dropdownList = document.getElementById("pioneer-tab-items-dropdown-list");
    
        // Toggle dropdown list visibility
        selectedOption?.addEventListener("click", () => {
          dropdownList.classList.toggle("active");
        });
    
        // Handle selecting an option from the dropdown
        const dropdownOptions = document.querySelectorAll(".dropdown-option");
        dropdownOptions.forEach((option) => {
          option.addEventListener("click", () => {
            const selectedValue = option.getAttribute("data-id");
            changeTab(selectedValue)
          });
        });

        const changeTab = (tabId) => {
            $('video').trigger('pause');
            $('.pioneer-tabs .tab', section).removeClass('active');
            $('.pioneer-tabs .tab-item', section).removeClass('active');
            $('.pioneer-tab-content .tab-item', section).removeClass('active');
            section.querySelector(`.pioneer-tab-content .tab-item[data-id="${tabId}"]`).classList.add('active');
            section.querySelector(`.pioneer-tabs .tab[data-id="${tabId}"]`).classList.add('active');
            dropdownList.classList.remove("active");
            section.querySelector(`.pioneer-tab-content .tab-item[data-id="${tabId}"]`).classList.add('active');
            let option = section.querySelector(`#pioneer-tab-items-dropdown-list .dropdown-option[data-id="${tabId}"]`)
            const selectedText = option.textContent;
            const selectedIcon = option.getAttribute("data-icon");
            selectedOption.innerHTML = `<i class="${selectedIcon}"></i>${selectedText}`;
        };

        if (window.location.search.length > 0) {
            const queryString = window.location.search;
            const queryStringWithoutQuestionMark = queryString.slice(1);
            const queryParams = queryStringWithoutQuestionMark.split('&');

            let paramValue = null;
            for (const param of queryParams) {
                const [key, value] = param.split('=');
                if (key === 'tab') {
                    paramValue = value;
                    break;
                }
            }

            if (paramValue !== null) {
                changeTab(paramValue - 1)
            } else {
                changeTab(0);
            }
        }

    })
}
if(document.querySelector('.popular-vehicles-tab-items')){
    $('.popular-vehicles-tabs').owlCarousel({
        loop:false,
        nav:true,
        dots: false,
        autoWidth:true,
        responsive:{
            0:{
                items:1
            },
            1000:{
                items:4
            },
            1200:{
                items:5
            }
        }
    })
    document.querySelectorAll('.popular-vehicles-tab-items').forEach((section) => {
        section.querySelectorAll('.popular-vehicles-tabs .tab').forEach((tab) => {
            tab.addEventListener('click', () => {
                changeTab(tab.getAttribute('data-id'));
            })
        })

        const selectedOption = document.getElementById("popular-vehicles-tab-items-selected-option");
        const dropdownList = document.getElementById("popular-vehicles-tab-items-dropdown-list");
    
        // Toggle dropdown list visibility
        selectedOption.addEventListener("click", () => {
          dropdownList.classList.toggle("active");
        });
    
        // Handle selecting an option from the dropdown
        const dropdownOptions = document.querySelectorAll(".dropdown-option");
        dropdownOptions.forEach((option) => {
          option.addEventListener("click", () => {
            const selectedValue = option.getAttribute("data-id");
            changeTab(selectedValue)
          });
        });

        const changeTab = (tabId) => {
            $('video').trigger('pause');
            $('.popular-vehicles-tabs .tab', section).removeClass('active');
            $('.popular-vehicles-tabs .tab-item', section).removeClass('active');
            $('.popular-vehicles-tab-content .tab-item', section).removeClass('active');
            section.querySelector(`.popular-vehicles-tab-content .tab-item[data-id="${tabId}"]`).classList.add('active');
            section.querySelector(`.popular-vehicles-tabs .tab[data-id="${tabId}"]`).classList.add('active');
            dropdownList.classList.remove("active");
            section.querySelector(`.popular-vehicles-tab-content .tab-item[data-id="${tabId}"]`).classList.add('active');
            let option = section.querySelector(`#popular-vehicles-tab-items-dropdown-list .dropdown-option[data-id="${tabId}"]`)
            const selectedText = option.textContent;
            const selectedIcon = option.getAttribute("data-icon");
            selectedOption.innerHTML = `<i class="${selectedIcon}"></i>${selectedText}`;
        };

        if (window.location.search.length > 0) {
            const queryString = window.location.search;
            const queryStringWithoutQuestionMark = queryString.slice(1);
            const queryParams = queryStringWithoutQuestionMark.split('&');

            let paramValue = null;
            for (const param of queryParams) {
                const [key, value] = param.split('=');
                if (key === 'tab') {
                    paramValue = value;
                    break;
                }
            }

            if (paramValue !== null) {
                changeTab(paramValue - 1)
            } else {
                changeTab(0);
            }
        }

    })
}

if(document.querySelector('.pioneer-tab-items .pioneer-tab-content .tab-item .gallery-row')){
    if(window.matchMedia('(max-width: 767px)').matches){
        $('.pioneer-tab-items .pioneer-tab-content .tab-item .gallery-row').owlCarousel({
            loop:false,
            margin:0,
            nav:true,
            dots: true,
            items: 1,
        })
    }
}
if(document.querySelector('.popular-vehicles-tab-items .popular-vehicles-tab-content .tab-item .gallery-row')){
    if(window.matchMedia('(max-width: 767px)').matches){
        $('.popular-vehicles-tab-items .popular-vehicles-tab-content .tab-item .gallery-row').owlCarousel({
            loop:false,
            margin:0,
            nav:true,
            dots: true,
            items: 1,
        })
    }
}

function centreCarousel(){
    setTimeout(function() {
        $(".popular-vehicles-slider, .popular-vehicles-tabs").each(function() {
            var thisWidth = $(this).width();
            var stageWidth = $(this).find(".owl-stage").width();
            if (thisWidth > stageWidth) {
                $(this).find(".owl-stage").css("margin-left", (thisWidth - stageWidth) / 2);
            } else {
                $(this).find(".owl-stage").css("margin-left", 0);
            }
        });
    }, 100)
};
if(document.querySelector('.product-tab-items')){
    document.querySelectorAll('.tabs').forEach(tabGroup => {
        const buttons = tabGroup.querySelectorAll('.tab-button');
        const contents = tabGroup.querySelectorAll('.tab-content');

        buttons.forEach(button => {
        button.addEventListener('click', () => {
            const tabId = button.getAttribute('data-tab');

            // Deactivate all in this tab group
            buttons.forEach(btn => btn.classList.remove('active'));
            contents.forEach(content => content.classList.remove('active'));

            // Activate selected
            button.classList.add('active');
            tabGroup.querySelector(`#${tabId}`).classList.add('active');
        });
        });
    });
}